@use '@design/design-tokens/typography/typography' as *;

@layer chart {
  .chartEmptyRoot {
    position: absolute;
    z-index: 1;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 300px;
    margin: 0 auto;
    background: linear-gradient(
      180deg,
      rgba(var(--background-default-rgb), 1) 0%,
      rgba(var(--background-default-rgb), 0.3) 100%
    );
  }

  .emptyImage {
    width: 70px;
    height: 70px;
  }

  .title {
    @include typography-v2-title-base;
    color: var(--text-default);
  }

  .description {
    @include typography-v2-body-sm;
    color: var(--text-soft);
    margin-bottom: 16px;
  }

  .link {
    color: var(--text-link);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
